// extracted by mini-css-extract-plugin
module.exports = {"NavbarHolder":"BottomNavigation_NavbarHolder__3bqdI","onFocus":"BottomNavigation_onFocus__1k3rN"};